// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1noA4","calendarButtons":"ClockData_calendarButtons__2ByDC"};